export default __webpack_public_path__ + "static/media/avatar_84.3004e54e.png";